import { useEffect, useState } from "react";
import { SurveyCompleted } from "../../../utils/api-objects/SurveyCompleted";
import { getLastSurveyUpdateByUserId, getSurveysByUserId } from "../../../utils/apis/emr-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { handleDayOfMonth, handleMonth, handleYear } from "../../../utils/Functions";

export const useGetSurveyData = (patientId: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [lastSurveyUpdate, setLastSurveyUpdate] = useState("");
    const [surveysCompleted, setSurveysCompleted] = useState<SurveyCompleted[]>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!patientId || !idToken) return;

        const fetchData = async () => {
            setIsLoading(true);

            try {
                // Fetch last survey update
                getLastSurveyUpdateByUserId(
                    patientId,
                    idToken,
                    (date) => {
                        const dateText = `${handleDayOfMonth(date)} ${handleMonth(date)} ${handleYear(date)}`;
                        setLastSurveyUpdate(dateText);
                    },
                    (error) => {
                        console.log("Survey update fetch error", error);
                    },
                );

                // Fetch all completed surveys
                getSurveysByUserId(
                    idToken,
                    patientId,
                    (surveys) => {
                        setSurveysCompleted(surveys);
                    },
                    (error) => {
                        console.log("Survey list fetch error", error);
                    },
                );
            } catch (error) {
                console.log("Survey data error", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [patientId, idToken])

    return { lastSurveyUpdate, surveysCompleted, isLoading };
}